import * as React from 'react';
import { useEffect, useCallback, useState } from 'react';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import {
  Typography, Grid, TextField, FormControl, Select, OutlinedInput
} from "@mui/material";
import Menu from '@mui/material/Menu';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as Arrow } from "../../assets/images/arrow-right.svg";
import { makeStyles } from "@mui/styles";
import { ReactComponent as TrashIcon } from "../../assets/images/portfolio/trash-alt.svg";
import { ReactComponent as BtnFilter } from "../../assets/images/btn-filter.svg";

const useStyles = makeStyles({
  btn: {
    fontSize: "18px !important",
    lineHeight: "24.59px !important",
    textDecoration: "underline !important",
    '& > svg': {
      marginLeft: "10px",
      marginBottom: "-2px",
    }
  },
  fillBlack: {
    '& > path': {
      fill: '#404349'
    },
    '& g > path': {
      fill: '#404349'
    },
  },
});

const styles = {
  td: {
    fontSize: "18px",
    lineHeight: "24.59px",
    textDecoration: "underline",
    '& > svg': {
      marginLeft: "10px",
      marginBottom: "-2px",
    }
  },
  iconBox: {
    width: "18px",
    height: "18px",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    marginRight: "9px"
  },
};

const requireField = (text) => {
  return (
    <Grid container direction="row">
      <Grid>
        <Typography style={{ fontSize: '18px', color: '#404349', fontWeight: '500' }}>{text}</Typography>
      </Grid>
      <Grid>
        <Typography style={{ color: '#cc6058', fontSize: '18px', fontWeight: 500 }}>&nbsp;*</Typography>
      </Grid>
    </Grid>)
}

export default function MoreDetailCustom(props) {
  const anchorRef = React.useRef(null);
  const { moreDetail, changeMoreDetail, warningMessage, verifyField, isOwner } = props
  const classes = useStyles();
  const { t, i18n } = useTranslation()

  return (
    <>
      <Grid container>
        <Grid item mb={2}>
          <Typography fontSize={22} lineHeight="39.6px" fontWeight="600" color="#404349">
            {t("mygoal.label.moreDetail")}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2} ml={2} pr={5}>
        {moreDetail?.map((item, idx) => {
          return (
            <>
              <Grid lg={12} xs={12} item>
                <Typography style={{ fontSize: '18px', color: '#404349', fontWeight: '500' }}>
                  {item.is_required ? requireField(item.label) : item.label}
                </Typography>
              </Grid>
              {item.type === 'text'
                ?
                <Grid lg={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                  <TextField
                    error={verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false} onChange={(e) => changeMoreDetail(e.target.value, item, idx)}
                    id="outlined-basic" placeholder={t('mygoal.placeholder.targetDetail')} value={item.value} variant="outlined"
                    required fullWidth size="small"
                    style={{ WebkitTextFillColor: !item.value ? '#A3A3A3' : '#404349', fontWeight: !item.value ? '300' : '400', fontSize: '16px', borderColor: (verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false) ? '#CC6058' : '#e1e1e1', paddingTop: '7px' }}
                    disabled={!isOwner}
                    sx={!isOwner ? { input: { backgroundColor: '#F3F3F3!important' } } : {}}
                  />
                  {((verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false) && !item.value) &&
                    warningMessage(verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false)
                  }
                </Grid>
                : item.type === 'textarea'
                  ?
                  <Grid lg={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                    <TextField
                      multiline
                      rows={2}
                      error={verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false} onChange={(e) => changeMoreDetail(e.target.value, item, idx)}
                      id="outlined-basic" placeholder={t('mygoal.placeholder.targetDetail')} value={item.value} variant="outlined"
                      required fullWidth size="small"
                      style={{ WebkitTextFillColor: !item.value ? '#A3A3A3' : '#404349', fontWeight: !item.value ? '300' : '400', fontSize: '16px', borderColor: (verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false) ? '#CC6058' : '#e1e1e1', paddingTop: '7px' }}
                      disabled={!isOwner}
                      sx={!isOwner ? { input: { backgroundColor: '#F3F3F3!important' } } : {}}
                    />
                    {((verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false) && !item.value) &&
                      warningMessage(verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false)
                    }
                  </Grid>
                  : item.type === 'dropdown'
                    ?
                    <Grid lg={12} item style={{ paddingTop: '10px', paddingBottom: '9px' }}>
                      <FormControl sx={{ minWidth: 80 }} fullWidth>
                        <Select
                          displayEmpty
                          error={verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false}
                          labelId="item.value"
                          id="item.value"
                          input={<OutlinedInput size="small" />}
                          value={item.value}
                          onChange={(e) => { changeMoreDetail(e.target.value, item, idx) }}
                          style={{ borderColor: (verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false) ? '#CC6058' : '#e1e1e1', }}
                          disabled={!isOwner}
                          classes={!isOwner ? { select: classes.disabled } : {}}
                          renderValue={(selected) => {
                            if (selected == null || selected == undefined || selected == "") {
                              return <Typography style={{ color: (item.value === null || item.value === undefined || item.value == "") ? '#A3A3A370' : '#404349', "-webkit-text-fill-color": "initial", fontStyle: 'normal', fontWeight: (item.value === null || item.value === undefined || item.value == "") ? '300' : '400', fontSize: '16px' }}>
                                {t('mygoal.placeholder.selectOption')}
                              </Typography>;
                            } else {
                              return i18n.language === "th-TH" ? item?.options?.data?.find((item) => item.id == selected)?.label?.th : item?.options?.data?.find((item) => item.id == selected)?.label?.en
                            }
                          }}
                        >
                          {item?.options?.data?.map((option, idx) => {
                            return <MenuItem key={idx} value={option.id}><Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>{i18n.language === "th-TH" ? option?.label?.th : option?.label?.en}</Typography></MenuItem>
                          })}
                        </Select>
                      </FormControl>
                      {((verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false) && (item.value === null || item.value === undefined)) &&
                        warningMessage(verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false)
                      }
                    </Grid>
                    :
                    <Grid lg={12} item>
                      <TextField
                        error={verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false} onChange={(e) => changeMoreDetail(e.target.value, item, idx)}
                        id="outlined-basic" placeholder={t('mygoal.placeholder.inputDetail')} value={item.value} variant="outlined"
                        required fullWidth size="small"
                        style={{ WebkitTextFillColor: !item.value ? '#A3A3A3' : '#404349', fontWeight: !item.value ? '300' : '400', fontSize: '16px', borderColor: (verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false) ? '#CC6058' : '#e1e1e1', paddingTop: '7px' }}
                        disabled={!isOwner}
                        sx={!isOwner ? { input: { backgroundColor: '#F3F3F3!important' } } : {}}
                      />
                      {((verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false) && !item.value) &&
                        warningMessage(verifyField.moreDetail?.length > 0 ? verifyField.moreDetail[idx] : false)
                      }
                    </Grid>
              }
            </>
          )
        })}
      </Grid>
    </>
  );
}